/* Colour-options tray — scroll affordance for the related-swatches row
 * (snippets/related-swatches.liquid, image style).
 * Ported from agents/reference/pdp-redesign-v3.html (.swrap/.swMore logic).
 *
 * The row scrolls sideways with a hidden scrollbar, which on its own gives
 * no hint that more colours exist off-screen. While content hides to the
 * right, the tray shows a fade + chevron over the last visible tile; the
 * chevron pages the row along, and both vanish at the end of the strip.
 */
(() => {
  class SwatchTray extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.track = this.querySelector('[data-tray-track]');
      this.moreBtn = this.querySelector('[data-tray-more]');
      if (!this.track || !this.moreBtn) return;

      // pending smooth-scroll destination, so fast taps page from where the
      // last tap was heading rather than from the mid-animation position
      this.target = null;

      this.track.addEventListener('scroll', () => {
        if (this.target !== null && Math.abs(this.track.scrollLeft - this.target) < 2) {
          this.target = null;
        }
        this.check();
      }, { passive: true });

      this.boundCheck = () => this.check();
      window.addEventListener('resize', this.boundCheck);
      this.moreBtn.addEventListener('click', () => this.page());
      this.check();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.boundCheck);
    }

    check() {
      const t = this.track;
      this.classList.toggle('swatch-tray--more', t.scrollLeft < t.scrollWidth - t.clientWidth - 2);
    }

    page() {
      const t = this.track;
      const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const base = this.target !== null ? this.target : t.scrollLeft;
      this.target = Math.min(base + t.clientWidth * 0.8, t.scrollWidth - t.clientWidth);
      t.scrollTo({ left: this.target, behavior: smooth ? 'smooth' : 'auto' });
    }
  }

  if (!window.customElements.get('swatch-tray')) {
    window.customElements.define('swatch-tray', SwatchTray);
  }
})();
